import React, { Component } from "react";

export default class NotFound2 extends Component {
  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100vh",
        }}
      >
        <div
          style={{
            margin: "0px 10px",
            borderRadius: "8px",
            border: "2px solid var(--brown1)",
            padding: "20px",
          }}
        >
          آدرسی که بدنبال آن هستید اشتباه است یا مجوز دسترسی به آن را ندارید
        </div>
      </div>
    );
  }
}
